import { RoundButton } from './RoundButton.tsx';
import { useClipboard } from '../../support/hooks/useClipboard.tsx';
import { CheckmarkIcon, CopyIcon } from '../icons/Icons.tsx';
import { useInstance } from '../../support/ioc/useInstance';
import { ITrackingEvent, TrackingService } from '../../support/tracking/TrackingService.ts';

export const CopyButton: React.FC<{
    value: string;
    size?: 'small' | undefined;
    trackingEvent?: ITrackingEvent;
    fill?: 'clear' | 'solid';
}> = ({ value, size, trackingEvent, fill }) => {

    const [copyToClipboard, justCopied] = useClipboard();
    const tracker = useInstance(TrackingService);

    const onCopyClicked = (e: React.MouseEvent) => {
        if (trackingEvent){
            tracker.trackWithDebounce(trackingEvent);
        }

        e.stopPropagation();
        e.preventDefault();
        copyToClipboard({ value });
    };

    return (
        <RoundButton
            size={size}
            fill={fill}
            onClick={(e: React.MouseEvent) => onCopyClicked(e)}
        >
            {!justCopied && (
                <CopyIcon color="medium" />
            )}
            {justCopied && (
                <CheckmarkIcon color="success" />
            )}
        </RoundButton>
    );
};
